import { connect } from 'react-redux';
import LeftNavigation from './LeftNavigation';
import { getUser } from '../../../store/selectors/user.selector';

const mapStateToProps = (state) => { 
    let user = getUser(state);

    if (!user.length) {
        user = localStorage.getItem('user');
    }

    return { user };
 };

export default connect(mapStateToProps, null)(LeftNavigation);